import DataSyncModal from 'growth-data-modal/components/DataSyncModal';
import { useHideDialog
// @ts-expect-error migrate upstream file
} from 'reporting-action-components/dialog/ducks';
import { DashboardUITracker
// @ts-expect-error migrate upstream file
} from '../../../tracking/DashboardUITracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataSyncModalContainer = () => {
  const hideDialog = useHideDialog();
  const handleOnClose = () => {
    hideDialog();
  };
  return /*#__PURE__*/_jsx(DataSyncModal, {
    hostApp: "reports-dashboard",
    trackerInstance: DashboardUITracker,
    withSyncRedirectParams: {
      via: 'reporting-non-empty-state'
    },
    withMarketplaceRedirectParams: {
      via: 'reporting-non-empty-state'
    },
    onClose: handleOnClose
  });
};